import * as profileStyles from './Profile.styles';
import ProfileDetails from './components/ProfileDetails';
import ProfileTabBar from './components/ProfileTabBar';

import OrderHub from '../OrderHub';
import PrivateRoute from '../Main/components/PrivateRoute';
import Loading from '../Loading';
import tracking, { setPageName, setPageRendered } from '../../utils/tracking';
import { TrackingEvent } from '../../utils/tracking/types';
import { fetchProfilePerform } from '../../store/profile/actions';
import { loadingProfile$ } from '../../store/loading/selectors';
import { profileState$ } from '../../store/profile/selectors';
import PageHead from '../PageHead';

import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

import type { PrivateRoutePath } from '../../utils/routes';
import type { ReactElement, ReactNode } from 'react';

const ProfileHead = () => <PageHead title="PROFILE" />;

interface ProfileProps {
  children: ReactNode;
}

function Profile({ children }: ProfileProps) {
  const { classes } = profileStyles.useStyles();

  const dispatch = useDispatch();

  const profile = useSelector(profileState$);
  const loading = useSelector(loadingProfile$);

  const router = useRouter();
  const routeTab = router.route as PrivateRoutePath.PROFILE | PrivateRoutePath.PROFILE_PRICING_PLAN;

  useEffect(() => {
    dispatch(fetchProfilePerform());
  }, [dispatch]);

  useEffect(() => {
    setPageName(TrackingEvent.VIEW_PROFILE);
    setPageRendered();
    tracking.event(TrackingEvent.VIEW_PROFILE);
  }, []);

  if (!profile && loading) {
    return (
      <>
        <ProfileHead />
        <Container className={classes.root}>
          <Loading />
        </Container>
      </>
    );
  }

  if (!profile) {
    return (
      <>
        <ProfileHead />
        <Container className={classes.root}>
          <Box
            display="flex"
            flexDirection="column"
            height="100%"
            alignItems="center"
            justifyContent="center"
            flexGrow={1}
          >
            <Typography variant="h4" component="span">
              We were unable to retrieve your profile.
            </Typography>
          </Box>
        </Container>
      </>
    );
  }

  return (
    <TabContext value={routeTab}>
      <ProfileHead />
      <ProfileTabBar />

      <div className={classes.root}>
        <TabPanel value={routeTab}>{children ?? <ProfileDetails />}</TabPanel>
      </div>
    </TabContext>
  );
}

Profile.getLayout = function getLayout(page: ReactElement) {
  return (
    <PrivateRoute>
      <OrderHub>{page}</OrderHub>
    </PrivateRoute>
  );
};

export default Profile;
